// Propósito: resolución pura de rutas y menús del sidebar.
export function moduleRoute(module: any): string {
  return pickRoute(module);
}

// Elige la ruta del módulo.
export function pickRoute(module: any): string {
  return module?.routeName || module?.acronym || '';
}

// Construye el mapa id -> ruta.
export function buildRouteMap(modules: any[]): Map<string, string> {
  const map = new Map<string, string>()
  for (const mod of modules) map.set(mod.id, moduleRoute(mod))
  return map
}

// Resuelve la URL del menú.
export function resolveMenuUrl(menu: any, map: Map<string, string>): string | null | undefined {
  if (!menu?.url) return undefined
  return fillRoute(menu.url, map.get(menu.moduleId))
}

// Rellena el placeholder de ruta.
export function fillRoute(url: string, route: string | undefined): string | null {
  if (!route) return missingRoute(url);
  return url.replace(':route', route)
}

// Maneja la ruta faltante.
export function missingRoute(url: string): string | null {
  if (url.includes(':route')) return null
  return url
}

// Convierte a ruta absoluta.
export function toAbsolute(url: string): string {
  if (url.startsWith('/')) return url
  return '/' + url
}

// Resuelve el árbol del menú.
export function resolveMenuTree(menu: any, map: Map<string, string>): any {
  const url = resolveMenuUrl(menu, map)
  if (url === null) return null
  return packItem(menu, map, url)
}

// Empaqueta el item con submenu resuelto.
export function packItem(menu: any, map: Map<string, string>, url: string | undefined): any {
  const item = { ...menu, submenu: resolveSubs(menu, map) }
  if (url !== undefined) item.url = toAbsolute(url)
  return item
}

// Resuelve los submenús.
export function resolveSubs(menu: any, map: Map<string, string>): any[] {
  const subs = menu?.submenu || []
  return resolveList(subs, map).filter((item) => isKept(item))
}

// Indica si el item se conserva.
export function isKept(item: any): boolean {
  return item !== null
}

// Resuelve una lista de menús.
export function resolveList(subs: any[], map: Map<string, string>): any[] {
  const out: any[] = []
  for (const item of subs) out.push(resolveMenuTree(item, map))
  return out
}

// Resuelve la lista raíz.
export function resolveMenus(menus: any[], map: Map<string, string>) {
  const out: any[] = []
  for (const item of menus || []) pushResolved(out, item, map)
  return out
}

// Agrega el item resuelto si es válido.
export function pushResolved(out: any[], menu: any, map: Map<string, string>) {
  const item = resolveMenuTree(menu, map)
  if (item !== null) out.push(item)
}
